import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';

const {
  formField: { loanPurpose, outstandingLoanType, onSystemProperty },
} = loanFormModel;

export class LoanPurposeValidation implements ValidationSchema {
  public name = loanPurpose.name;
  public label = loanPurpose.label;
  public dependsOn: string[] = [
    outstandingLoanType.name,
    onSystemProperty.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    typeOfLoan: string,
    onSystemProperty: string,
    schema: Yup.StringSchema,
    context: any
  ) {
    if (loanPurpose.getRequired(typeOfLoan) && onSystemProperty !== 'Yes') {
      return schema.required(loanPurpose.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new LoanPurposeValidation());
